import React from 'react';
import { Link } from 'react-router-dom';
import Button from './ui/button';

const Hero = () => {
  return (
    <section
      className="h-[55vh] sm:h-[70vh] md:h-[90vh] lg:h-[92vh] bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: "url('/images/home-banner-1.webp')"
      }}
    >
      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}
      />
      
      {/* Hero Content */}
      <div className="relative z-10 flex items-center h-full px-3 sm:px-8 md:px-16 lg:px-24">
        <div className="text-left text-white max-w-2xl ml-0 sm:ml-8 md:ml-24 lg:ml-48 xl:ml-72">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 sm:mb-6 leading-tight">
            More than <span className="font-normal" style={{ color: '#db0058' }}>just data.</span>
          </h1>
          <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8 leading-relaxed max-w-xs sm:max-w-none">
            <strong>We have an industry-compliant database<br className="hidden sm:block" />
            <span className="sm:hidden"> </span>of over 51 million UK consumers.</strong><br />
            But don't just choose us because of that.
          </p>
          <Link to="/data-consultancy" onClick={() => window.scrollTo(0, 0)}>
            <Button variant="primary" size="medium">
              Find out more
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
